<div class ="main">
        <div class ="start">
            <audio autoplay loop src="./../../assets/Audios/saferoombg.mp3"></audio>

            <div class = "boxes">
                <div class ="box" *ngFor="let x of safedata" routerLink={{x.link}}>{{x.name}}</div>
                <a class ="box" href="https://elderlycomplexagents.jv20201.repl.co/">Vortex</a>
                <a class ="box" href="https://bigpreemptivedecagons--jv20201.repl.co/">Waves</a>
                <!-- <a src = "https://elderlycomplexagents.jv20201.repl.co/"><div class ="box" >Vortex</div></a> -->
                <!-- <div class ="box" src="">Waves</div> -->
                <!-- <div class ="container" *ngFor="let x of safedata" data-tilt data-tilt-scale="0.95" data-tilt-startY="40">{{x.name}}</div> -->
            </div>

        </div>
    
</div>